import { render, staticRenderFns } from "./accountButton.vue?vue&type=template&id=6b1350fa&scoped=true"
import script from "./accountButton.vue?vue&type=script&lang=js"
export * from "./accountButton.vue?vue&type=script&lang=js"
import style0 from "./accountButton.vue?vue&type=style&index=0&id=6b1350fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1350fa",
  null
  
)

export default component.exports